import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/[slug]/blog-content.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/RecentPostsSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
